import styled from 'styled-components';
import { devices } from 'shared/styles/components';

export const HeaderContainer = styled.header`
  position: fixed;
  display: grid;
  grid-template-columns: repeat(var(--page-grid-cols), 1fr);
  gap: 0 20px;
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
  background-color: ${(props) => props.theme.colors.bgPrimaryAlpha};
  backdrop-filter: blur(8px);
  border-bottom: 2px solid ${(props) => props.theme.colors.border};
  z-index: 1000;
`;

export const HeaderContent = styled.div`
  display: flex;
  grid-column: span var(--page-grid-cols);
`;

export const HeaderNavigationContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
`;

export const HeaderLogoWrapper = styled.div`
  position: relative;
  display: flex;
  transition: transform 200ms ease;

  a {
    display: flex;
  }

  @media (hover: none) {
    &:active {
      transform: scale(0.92);
    }
  }

  @media (hover: hover) and (min-width: 801px) {
    &:hover {
      transform: rotate(-8deg) scale(1.1);
    }

    &:hover .logo-tooltip {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
      pointer-events: auto;
    }
  }

  .logo-tooltip {
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%) translateY(4px);
    padding: 8px 4px;
    min-width: 130px;
    background-color: ${({ theme }) => theme.colors.bgPrimary};
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    text-align: center;
    color: ${({ theme }) => theme.colors.textSecondary};
    user-select: none;
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    transition:
      opacity 200ms ease,
      transform 200ms ease,
      pointer-events 0ms;

    &::before {
      content: '';
      position: absolute;
      top: -4px;
      left: 50%;
      transform: translateX(-50%) rotate(45deg);
      width: 8px;
      height: 8px;
      background-color: ${({ theme }) => theme.colors.bgPrimary};
      box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.05);
    }

    &::after {
      content: '';
      position: absolute;
      top: -12px;
      left: 0;
      right: 0;
      height: 12px;
    }
  }

  &.tapped {
    transform: rotate(-8deg) scale(1.1);
  }

  &.tapped .logo-tooltip {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
    pointer-events: auto;
  }
`;

export const HeaderLinks = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  color: ${(props) => props.theme.colors.textPrimary};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  cursor: default;

  & > a {
    padding: 20px;
    transition: color 0.2s;
    cursor: pointer;
    user-select: none;

    &.active,
    &:hover {
      color: ${(props) => props.theme.colors.textTertiary};
    }
  }

  @media ${devices.tabletMax} {
    display: none;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  .theme-toggle {
    display: flex;
    cursor: pointer;

    &:hover svg {
      fill: ${(props) => props.theme.colors.textPrimary};
    }

    svg {
      fill: ${(props) => props.theme.colors.textSecondary};
      width: 20px;
      height: 20px;
      transition: fill 0.2s;
    }
  }

  .root-link {
    @media ${devices.tabletMax} {
      display: none;
    }
  }

  @media ${devices.tabletMax} {
    gap: 16px;
  }
`;

export const HeaderSocial = styled.div`
  display: flex;
  margin-left: 12px;

  a {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 36px;
    line-height: 1;
    color: ${(props) => props.theme.colors.textSecondary};
    transition: color 0.2s;

    &:hover {
      color: ${(props) => props.theme.colors.textPrimary};

      svg {
        fill: ${(props) => props.theme.colors.textPrimary};
      }
    }

    svg {
      fill: ${(props) => props.theme.colors.textSecondary};
      width: 20px;
      height: 20px;
      transition: fill 0.2s;
    }
    span {
      margin-top: 1px;
      font-size: 14px;
      font-family: 'Anonymous Pro', monospace;
      line-height: 1;
    }
  }

  @media ${devices.tabletMax} {
    display: none;
  }
`;
